import APIService from '@/services/APIService.js';

export default {
  getAll(expirados = false) {
    return APIService.apiCall().get(`/indicadorPrazos/getAll/${expirados}`);
  },

  getById(id) {
    return APIService.apiCall().get(`/indicadorPrazos/getById/${id}`);
  },

  salvar(id, data) {
    return APIService.apiCall().post(`/indicadorPrazos/salvar/${id}`, JSON.stringify(data));
  },

  executar(id) {
    return APIService.apiCall().get(`/indicadorPrazos/executar/${id}`);
  },

  deletar(id) {
    return APIService.apiCall().post(`/indicadorPrazos/deletar/${id}`);
  },

  duplicar(id) {
    return APIService.apiCall().post(`/indicadorPrazos/duplicar/${id}`);
  },

  download(id, config = {}) {
    return APIService.apiCall().get(`/indicadorPrazos/baixar/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
